import React from 'react';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { CarvanaHeaderProvider } from '@carvana/header';
import { MicroFEComponent } from '@carvana/microfrontend';
import ErrorBoundary from '~/components/ErrorBoundary';
import ErrorPage from '~/components/ErrorPage';
import ScrollToTop from '~/shared/ScrollToTop';
import store, { history } from './store';
import { theme } from './theme';
import Routes from './Routes';

// eslint-disable-next-line
const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Brandon Text';
    font-display: auto;
    font-weight: 300;
    font-style: normal;
    src: url("${process.env.CARVANA_APP_CAMPAIGNS_ASSETS_URL}/fonts/BrandonText-Light.otf");
  }
  @font-face {
    font-family: 'Brandon Text';
    font-display: auto;
    font-weight: 400;
    font-style: normal;
    src: url("${process.env.CARVANA_APP_CAMPAIGNS_ASSETS_URL}/fonts/BrandonText-Regular.otf");
  }
  @font-face {
    font-family: 'Brandon Text';
    font-display: auto;
    font-weight: 700;
    font-style: normal;
    src: url("${process.env.CARVANA_APP_CAMPAIGNS_ASSETS_URL}/fonts/BrandonText-Bold.otf");
  }
  @font-face {
    font-family: 'Brandon Text Black';
    font-display: auto;
    font-weight: 700;
    font-style: normal;
    src: url("${process.env.CARVANA_APP_CAMPAIGNS_ASSETS_URL}/fonts/BrandonText-Black.otf");
  }

  @font-face {
    font-family: 'Inter Light';
    font-display: auto;
    font-weight: 300;
    font-style: normal;
    line-height: 150%;
    src: url("${process.env.CARVANA_APP_CAMPAIGNS_ASSETS_URL}/fonts/Inter-Light.otf");
  }
  @font-face {
    font-family: 'Inter';
    font-display: auto;
    font-weight: 400;
    font-style: normal;
    line-height: 150%;
    src: url("${process.env.CARVANA_APP_CAMPAIGNS_ASSETS_URL}/fonts/Inter-Regular.otf");
  }
  @font-face {
    font-family: 'Inter Bold';
    font-display: auto;
    font-weight: 700;
    font-style: normal;
    letter-spacing: -1%;
    line-height: 150%;
    src: url("${process.env.CARVANA_APP_CAMPAIGNS_ASSETS_URL}/fonts/Inter-Bold.otf");
  }
  @font-face {
    font-family: 'Inter Black';
    font-display: auto;
    font-weight: 700;
    font-style: normal;
    letter-spacing: -1%;
    line-height: 150%;
    src: url("${process.env.CARVANA_APP_CAMPAIGNS_ASSETS_URL}/fonts/Inter-Black.otf");
  }

  .d-flex { display: flex !important; }
  .d-none { display: none !important; }
`;

const BodyWrapper = styled.div`
  background-color: ${theme.carvana.body};
  ${
    '' /* background: linear-gradient(350deg, rgba(0, 0, 0, 0.1) 0%, rgba(255, 255, 255, 0.9) 50%), */
  }
  ${'' /* url('/tracks2.jpg') repeat; */}
  background-attachment: fixed;
  font-family: 'Brandon Text', sans-serif;
`;

const PageWrapper = styled.div`
  margin: 0 auto;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.05);
  max-width: ${props => props.theme.breakpoints.values.xl}px;
`;

const Campaigns = () => (
  <Provider store={store}>
    <CarvanaHeaderProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <BodyWrapper>
          <PageWrapper>
            <ErrorBoundary FallbackComponent={<ErrorPage />}>
              <Router history={history} basename="/spinner">
                <ScrollToTop />
                <Routes />
              </Router>
            </ErrorBoundary>
          </PageWrapper>
          <MicroFEComponent id="default" module="FooterModule">
            {({ Component: FooterComponent }) => (
              <FooterComponent
                environment={process.env.CARVANA_APP_ENVIRONMENT}
                isPartner={false}
              />
            )}
          </MicroFEComponent>
        </BodyWrapper>
      </ThemeProvider>
    </CarvanaHeaderProvider>
  </Provider>
);

export default Campaigns;
